/**
 * Terms other than price (ADR 0033 §3): each term's value as the owner reads it, the agreed terms on the sign card and
 * in the agents' talk, a worker's own preferences on their card, and the scope chips read from a household's words.
 */
export const terms = {
    "terms.title": "Agreed besides the price",
    "terms.proposed": "Terms: {terms}",
    "terms.when": "{day}, {window}",
    "terms.window.morning": "morning",
    "terms.window.afternoon": "afternoon",
    "terms.window.evening": "evening",
    "terms.materials.worker": "the worker buys the materials",
    "terms.materials.household": "the household buys the materials",
    "terms.coats.one": "{count} coat of paint",
    "terms.coats.other": "{count} coats of paint",
    "terms.hours.one": "{count} hour a day",
    "terms.hours.other": "{count} hours a day",
    "terms.you_asked": "(you asked: {value})",
    "terms.check": "Your agent took terms you did not ask for. Check them before you sign.",
    "terms.card": "When you work and what you bring",
    "terms.card_windows": "Parts of the day you take work",
    "terms.card_days": "Days you work",
    "day.1": "Mon",
    "day.2": "Tue",
    "day.3": "Wed",
    "day.4": "Thu",
    "day.5": "Fri",
    "day.6": "Sat",
    "day.7": "Sun",
    "terms.card_public": "Households see your days and times on your card, so they ask you only when you work. Your bookings stay on this phone.",
    "terms.card_materials": "Who buys the materials",
    "terms.card_either": "Either",
    "terms.card_mine": "I bring them",
    "terms.card_theirs": "The household buys",
    "terms.card_hours": "Most hours a day",
    "terms.card_any": "Any",
    "terms.scope_read": "From what you wrote, I read this. Tap one that is wrong to remove it.",
    "terms.scope_ok": "Yes, that's right",
    "terms.scope_none": "None of these",
    "terms.chip.rooms.one": "{count} room",
    "terms.chip.rooms.other": "{count} rooms",
    "terms.chip.area_sqft": "{count} sq ft",
    "terms.chip.people.one": "{count} person",
    "terms.chip.people.other": "{count} people",
    "terms.chip.meals.one": "{count} meal a day",
    "terms.chip.meals.other": "{count} meals a day",
    "terms.chip.labour_yes": "You buy the paint",
    "terms.chip.labour_no": "The painter brings the paint",
    "terms.chip.flexible": "Any time that day is fine",
    "terms.reading": "Reading what you wrote…",
};
//# sourceMappingURL=terms.js.map